import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  col: {
    flex: '1 1 100%',
  },
})

export default useStyles
